import React, { useState } from "react";
import { HeadFC, PageProps, graphql, navigate } from "gatsby";
import { usePageContext } from "@/contexts/Page";
import { Layout } from "@/layout/Layout";
import { Seo } from "@/components/Seo";

const Eventos: React.FC<PageProps<{ wpPage: any }>> = ({ data }) => {
  const { wpPage } = data;

  const [loading, setLoading] = useState<boolean>(false);
  const [showMore18Error, setShowMore18Error] = useState<boolean>(false);
  const { setPageType, setSlug } = usePageContext();
  const [formState, setFormState] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    surname: "",
    more18: false,
    accepts_advertising: false,
    source: typeof window !== `undefined` ? window.location.href : "",
    form: "event",
    asistentes: "",
    empresa: "",
    fecha: "",
    suscribed: false,
    utm_medium: "form",
    utm_campaign: "event_form",
    utm_source: "A&G WebPage",
  });

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = event.target;
    const { target } = event;

    if (name === "verification") {
      return;
    }

    // Manejar checkbox para mayor de 18 años
    if (name === "more18") {
      const checked = (target as HTMLInputElement).checked;
      setFormState((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
      if (checked) {
        setShowMore18Error(false);
      }
      return;
    }
    
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Validación personalizada del checkbox "more18" 
    // para garantizar que el usuario es mayor de 18 años
    if (!formState.more18) {
      setShowMore18Error(true);
      return;
    }

    setLoading(true);

    fetch(`${process.env.GATSBY_WORDPRESS_URL}/wp-json/whiz-api/v1/lead`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formState),
      redirect: "follow",
    })
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error))
      .finally(() => {
        setLoading(false);
        navigate("/eventos-gracias");
      });
  };

  React.useEffect(() => {
    if (setPageType) {
      setPageType("normal");
    }
    if (setSlug) {
      setSlug(wpPage.slug);
    }
  }, []);

  return (
    <Layout
      footerRedirections={true}
      headerTransition={true}
      mainId={`events-page`}
      footer={true}
    >
      <section className="hero-banner">
        <img
          src={wpPage.featuredImage.node.publicUrl}
          alt={wpPage.featuredImage.node.title}
        />
        <div className="hero-banner__layout"></div>
      </section>

      <section className="events">
        {wpPage.eventos.rooms ? (
          wpPage.eventos.rooms.map((element: any, index: any) => (
            <div className="events__element" key={index}>
              <img
                src={element.imagen.node.publicUrl}
                alt={element.imagen.node.title}
                className="element__image"
              />
              <div
                className={`element__content ${
                  index % 2 === 0 ? "left" : "right"
                }`}
              >
                <h3 className="content__title">{element.titulo}</h3>
                <div
                  className="content__description"
                  dangerouslySetInnerHTML={{
                    __html: element.description,
                  }}
                ></div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </section>

      <section className="bookings">
        <div className="container-fluid">
          <div
            className="row center-xs"
            style={{
              justifyContent: "space-evenly",
              maxWidth: "1650px",
              margin: "0 auto",
            }}
          >
            <div className="col-xs-12 col-lg-4">
              <div className="bookings__content">
                <h3 className="content__title">{wpPage.eventos.formTitle}</h3>
                <p className="content__description">
                  {wpPage.eventos.formDescription}
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-lg-6">
              <form onSubmit={handleSubmit} className="form__element">
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="text"
                      name="name"
                      placeholder="Nombre*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="text"
                      name="surname"
                      placeholder="Apellido*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="tel"
                      name="phone"
                      placeholder="Celular*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="text"
                      name="empresa"
                      placeholder="Nombre de la empresa*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="email"
                      name="email"
                      placeholder="Correo*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="date"
                      name="fecha"
                      placeholder="Fecha*"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <input
                      required
                      type="number"
                      name="asistentes"
                      placeholder="Número de asistentes"
                      className="form-control"
                      onChange={handleInputChange}
                      min="12"
                    />
                  </label>
                </div>
                <div className="form-group complete">
                  <label className="form-label">
                    <textarea
                      name="message"
                      placeholder="Comentarios"
                      className="form-control comments"
                      onChange={handleInputChange}
                    />
                  </label>
                </div>
                <div className="form-group__complete checkboxes">
                  <span className="form-instructions">
                    *Campos obligatorios
                  </span>
                  <label className="form-label">
                    <input
                      type="checkbox"
                      name="more18"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                    Declaro que soy mayor de 18 años
                  </label>
                  {showMore18Error && (
                    <p className="form-error-message">
                      Para la solicitud de información sobre los eventos privados, 
                      es necesario que el/la solicitante sea mayor de 18 años. 
                    </p>
                  )}
                  <label className="form-label">
                    <input
                      required
                      type="checkbox"
                      name="verification"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                    He leído y acepto las políticas de privacidad de datos de
                    esta web.
                  </label>
                  <label className="form-label">
                    <input
                      type="checkbox"
                      name="accepts_advertising"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                    Acepto el tratamiento de mis datos para fines publicitarios (Opcional)
                  </label>
                </div>
                <div className="form-group__complete">
                  <div className="button-container">
                    <button
                      type="submit"
                      className="style-2 form-button"
                      disabled={loading}
                    >
                      {loading ? "Enviando..." : wpPage.eventos.formButtonText}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Eventos;
export const Head: HeadFC<{ wpPage: any }> = ({ data }) => {
  const { wpPage } = data;
  return (
    <Seo
      metaDescription={wpPage.seo.metaDesc}
      metatitle={wpPage.seo.title}
      seoDescription={wpPage.seo.opengraphDescription}
      seoTitle={wpPage.seo.opengraphTitle}
      SeoImage={wpPage.seo.opengraphImage?.publicUrl}
      seoType={wpPage.seo.opengraphType}
      SeoUrl={wpPage.seo.opengraphUrl}
    />
  );
};

export const pageQuery = graphql`
  query EventosQuery {
    wpPage(slug: { eq: "eventos" }) {
      id
      featuredImage {
        node {
          publicUrl
          title
        }
      }
      eventos {
        formTitle
        formDescription
        formButtonText
        rooms {
          description
          titulo
          imagen {
            node {
              publicUrl
              title
            }
          }
        }
      }
      seo {
        title
        metaDesc
        opengraphUrl
        opengraphType
        opengraphTitle
        opengraphDescription
        opengraphImage {
          publicUrl
        }
      }
    }
  }
`;
